























































































import { Component, Vue } from 'vue-property-decorator';
import { ContactDetailsModule } from '@/store/modules/contactDetails'
import PageNames from '@/router/PageNames';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import GiganautVue from '@/components/Shared/GiganautVue';
import AddressUtils from '@/lib/addressUtils';
import ContactLocationCreate from '@/components/Contacts/ContactLocationCreate.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'ContactLocationList',
  components: { ContactLocationCreate }
})
export default class extends GiganautVue {

    infoWindowPos: any = null;
    infoWinOpen = false;
    currentMidx: any = null;

    infoOptions: any = {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
            width: 0,
            height: -35
        }
    };

    async created() {
        await  ContactDetailsModule.getContactLocations();
    }

    get loadingLocations() {
        return ContactDetailsModule.loadingContactLocations;
    }

    get locations() {
        return ContactDetailsModule.contactLocations;
    }

    async deleteContactLocation(contactLocationId: string) {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this association?', options);
        if (result) {
            await ContactDetailsModule.deleteContactLocation(contactLocationId);
        }
    }

    async navigateToLocation(item: ContactLocationDto) {
        const locationId = item.locationId;
        this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: locationId } });
    }

      async toggleInfoWindow(location: ContactLocationDto, idx: any) {
        this.infoWindowPos = {lng:location.location.geometry.lng,lat:location.location.geometry.lat}
        this.infoOptions.content = "<p class='body-2'>" + location.location.brandName + "</p><p>" + AddressUtils.fullAddressLine(location.location) + "</p><p><a href='" + window.location + "/" + location.locationId + "' target='_blank'>Open in new tab</a>";

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

        }
  }

    private search = '';
  
    private headers = [
    { text: 'Brand Name', value: 'location.brandName' },
    { text: 'Address' },
    { text: AppModule.currentAgencyContext.labels.location + ' Type'},
    { text: 'Actions'},
    ]
}
